import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "titulo m-0" }, "Grupos", -1)
const _hoisted_4 = { class: "legenda" }
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content"},
  class: "m-0 fas fa-arrow-left"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Voltar", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content"},
  class: "m-0 fas fa-plus"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Adicionar", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  class: "col-12 d-flex flex-column justify-content-between align-items-center p-0 overflow-hidden",
  style: {"border-radius":"14px"}
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex w-100 p-4 gap-2\" style=\"background:#203972;\"><p class=\"titulo m-0 text-white\" style=\"width:13rem;\">Código</p><p class=\"titulo m-0 text-white\" style=\"width:60%;\">Grupo</p><p class=\"titulo m-0 text-white\" style=\"width:40%;\">Responsável</p><p class=\"titulo m-0 text-white\" style=\"width:18rem;\">Configurações</p></div>", 1)
const _hoisted_14 = { class: "d-flex w-100 flex-column bg-white" }
const _hoisted_15 = {
  key: 0,
  class: "w-100 d-flex justify-content-center align-items-center p-10"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Nenhum dado foi encontrado", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["title"]
const _hoisted_21 = ["title"]
const _hoisted_22 = ["title"]
const _hoisted_23 = {
  style: {"white-space":"nowrap","width":"18rem"},
  class: "texto bold cor_texto_1 d-inline-block text-trunate m-0"
}
const _hoisted_24 = { style: {"color":"#203972"} }
const _hoisted_25 = { style: {"color":"#F64E60"} }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_27 = {
  class: "col-12 d-flex justify-content-center align-items-center p-3",
  id: "load"
}
const _hoisted_28 = {
  key: 0,
  style: {"color":"#dc3545"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  style: {"font-weight":"bold","font-size":"10"},
  class: "m-0 p-0 text-danger"
}
const _hoisted_32 = {
  key: 2,
  style: {"font-weight":"bold","font-size":"10"},
  class: "m-0 p-0 text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_ModalGrupo = _resolveComponent("ModalGrupo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.arrayGrupo.length) + " resultados", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.history.back())),
          class: "btn btn-light-danger bg-white d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center"
        }, _hoisted_8),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectToEdit(null))),
          class: "btn btn-light-danger bg-white d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center"
        }, _hoisted_11)
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        (!_ctx.loadGrupo && _ctx.arrayGrupo.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : _createCommentVNode("", true),
        (_ctx.skeleton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_el_skeleton, {
                animated: "",
                rows: 15,
                class: "text-center p-5 d-block"
              })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayGrupo, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            onClick: ($event: any) => (_ctx.redirectToEdit(item.codGrupo)),
            class: "d-flex p-5 gap-2 cursor-pointer",
            style: _normalizeStyle(i%2 == 0 ? 'background: white !important;' : 'background: #f9f9f9 !important;')
          }, [
            _createElementVNode("p", {
              style: {"white-space":"nowrap","width":"13rem"},
              class: "texto bold cor_texto_1 d-inline-block text-truncate m-0",
              title: item.codGrupo
            }, _toDisplayString(item.codGrupo), 9, _hoisted_20),
            _createElementVNode("p", {
              style: {"white-space":"nowrap","width":"60%"},
              class: "texto bold cor_texto_1 d-inline-block text-truncate m-0",
              title: item.nome
            }, _toDisplayString(item.nome), 9, _hoisted_21),
            _createElementVNode("p", {
              style: {"white-space":"nowrap","width":"40%"},
              class: "texto bold cor_texto_1 d-inline-block text-truncate m-0",
              title: item.responsavel
            }, _toDisplayString(item.responsavel), 9, _hoisted_22),
            _createElementVNode("p", _hoisted_23, [
              _createElementVNode("b", _hoisted_24, _toDisplayString(item.buscaPlaca + item.usaChecklist + (item.oleoFracionado == 'S' ? 1 : 0) + (item.alterarValor == 'S' ? 1 : 0) + (item.podeDesconto == 'S' ? 1 : 0) + (item.formularioDeRecepcao == 'S' ? 1 : 0) + (item.assinaturaDoCliente == 'S' ? 1 : 0) + (item.utilizaMO == 'S' ? 1 : 0) + (item.vendaEstoqueNegativo == 'S' ? 1 : 0) + (item.tipoApp !== null && item.tipoApp !== 0 ? 1 : 0) + (item.checklistAdicional !== null && item.checklistAdicional !== 0 ? 1 : 0) + (item.tipoOferta !== null && item.tipoOferta !== 0 ? 1 : 0)), 1),
              _createTextVNode(" ativas    "),
              _createElementVNode("b", _hoisted_25, _toDisplayString(12 - (item.buscaPlaca + item.usaChecklist + (item.oleoFracionado == 'S' ? 1 : 0) + (item.alterarValor == 'S' ? 1 : 0) + (item.podeDesconto == 'S' ? 1 : 0) + (item.formularioDeRecepcao == 'S' ? 1 : 0) + (item.assinaturaDoCliente == 'S' ? 1 : 0) + (item.utilizaMO == 'S' ? 1 : 0) + (item.vendaEstoqueNegativo == 'S' ? 1 : 0) + (item.tipoApp !== null && item.tipoApp !== 0 ? 1 : 0) + (item.checklistAdicional !== null && item.checklistAdicional !== 0 ? 1 : 0) + (item.tipoOferta !== null && item.tipoOferta !== 0 ? 1 : 0) )), 1),
              _createTextVNode(" inativas ")
            ])
          ], 12, _hoisted_19))
        }), 128))
      ]),
      _hoisted_26
    ]),
    _createElementVNode("section", _hoisted_27, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscaGruposPaginado(_ctx.pagina ? _ctx.pagina + 1 : 1))),
        style: {"width":"15rem","height":"3.2rem"},
        class: "card d-none flex-row gap-2 justify-content-center align-items-center cursor-pointer",
        id: "loadGrupoButton"
      }, [
        (_ctx.loadGrupo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
          : _createCommentVNode("", true),
        (_ctx.loadGrupo)
          ? (_openBlock(), _createElementBlock("p", _hoisted_31, "Carregando mais"))
          : _createCommentVNode("", true),
        (!_ctx.loadGrupo)
          ? (_openBlock(), _createElementBlock("p", _hoisted_32, "Carregar mais"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalGrupo, {
      fechaModal: _ctx.fechaModal,
      grupo: _ctx.grupoSelecionado
    }, null, 8, ["fechaModal", "grupo"])
  ]))
}